import { TableController } from './table.controller'

export class TableContextController {
  static lazy = Symbol('lazy')

  constructor() {
    this.tables = new Map()
  }

  addTable(key, tableRef) {
    const table = this.tables.get(key)

    if (table?.empty) {
      table.setTableRef(tableRef)

      // If table ref has state, sync the page with the controller
      if (tableRef?.state?.page !== undefined) {
        table.currentPage = tableRef.state.page;
      }

      return
    }

    this.tables.set(key, new TableController(key, tableRef))
  }

  getTable(key) {
    if (this.tables.has(key)) {
      return this.tables.get(key)
    }

    const emptyController = new TableController(key)
    this.tables.set(key, emptyController)
    return emptyController
  }

  removeTable(key) {
    this.tables.delete(key)
  }

  dispose() {
    this.tables.clear()
  }

  // New method to set page on a specific table
  setTablePage(key, pageIndex) {
    const table = this.getTable(key);
    if (table) {
      table.setPage(pageIndex);
      return true;
    }
    return false;
  }
}
